// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".cc5bd1c8{transition:all .3s ease}", "",{"version":3,"sources":["webpack://./src/common/components/Collapsible/Collapsible.scss"],"names":[],"mappings":"AAAA,UACE,uBAAA","sourcesContent":[".collapsible {\n  transition: all 0.3s ease;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"collapsible": "cc5bd1c8"
};
export default ___CSS_LOADER_EXPORT___;
